import React from "react";

function CartItemsinCheckout({ item }) {
  const image = item.thumbnail;
  const title = item.title;
  const variantName = item.variantName;
  const quantity = item.quantity;
  const mrp = item.mrp;
  const subtotal = item.subtotal;
  const customization = item.customization

  const price = item?.price.toFixed(2);

  return (
    <li className="order-item">
      <figure className="img-product">
        <img src={image} alt="product" />
      </figure>
      <div className="content">
        <div className="info">
          <p className="name text-sm fw-medium">{title}</p>
          <span className="variant">{variantName}</span>
          <span className="variant">
            Qty: <b>{quantity}</b>
          </span>
             {customization.add_personalised_text && 
          <p className="text-muted fw-bold mt-1">Print: <span>{customization.add_personalised_text}</span></p>}
        </div>
        
        <span className="price text-sm fw-medium text-end">
          <span className="price text-sm fw-medium">₹{price}/-</span>

          {!isNaN(mrp) && mrp > price && (
            <span className="text-decoration-line-through text-dark-1">
              ₹{mrp.toFixed(2)}/-
            </span>
          )}<br/>

          <span className="price text-sm fw-medium">₹{subtotal}/-</span>
        </span>
      </div>
    </li>
  );
}

export default CartItemsinCheckout;
